let registrationPromise: Promise<ServiceWorkerRegistration | null> | null =
  null;

export function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (!('serviceWorker' in navigator)) return Promise.resolve(null);
  if (registrationPromise) return registrationPromise;

  registrationPromise = navigator.serviceWorker
    .register('/sw.js', { scope: '/' })
    .then((reg) => reg)
    .catch((e) => {
      console.warn('[sw] échec enregistrement', e);
      return null;
    });
  return registrationPromise;
}

export async function getActiveRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (typeof window === 'undefined') return null;
  if (!('serviceWorker' in navigator)) return null;
  const reg = await registerServiceWorker();
  if (!reg) return null;
  if (reg.active) return reg;
  // Attend l'activation du SW (max ~3 s)
  await new Promise<void>((resolve) => {
    const installing = reg.installing ?? reg.waiting;
    if (!installing) {
      resolve();
      return;
    }
    const onChange = () => {
      if (installing.state === 'activated') {
        installing.removeEventListener('statechange', onChange);
        resolve();
      }
    };
    installing.addEventListener('statechange', onChange);
    setTimeout(resolve, 3000);
  });
  return navigator.serviceWorker.ready.catch(() => reg);
}

export function supportsNotificationTriggers(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof Notification === 'undefined') return false;
  if (!('showTrigger' in Notification.prototype)) return false;
  return (
    typeof (window as unknown as { TimestampTrigger?: unknown })
      .TimestampTrigger === 'function'
  );
}

export function isIosStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = navigator as unknown as { standalone?: boolean };
  const standalone =
    nav.standalone === true ||
    window.matchMedia?.('(display-mode: standalone)').matches === true;
  const ua = navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(ua);
  return isIos && standalone;
}

export function isIosWeb(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) && !isIosStandalone();
}
